// Delta Indicator Component - Shows change from previous snapshot

import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

interface DeltaIndicatorProps {
  delta: number | null;
  showValue?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export default function DeltaIndicator({ delta, showValue = true, size = 'md' }: DeltaIndicatorProps) {
  if (delta === null || delta === undefined) {
    return (
      <span className="text-gray-400 flex items-center gap-1">
        <Minus size={size === 'sm' ? 14 : size === 'lg' ? 22 : 18} />
        {showValue && <span className="text-xs">New</span>}
      </span>
    );
  }

  const iconSize = size === 'sm' ? 14 : size === 'lg' ? 22 : 18;
  const textSize = size === 'sm' ? 'text-xs' : size === 'lg' ? 'text-base' : 'text-sm';

  if (delta > 0) {
    return (
      <span className={`text-green-600 flex items-center gap-1 font-semibold ${textSize}`}>
        <TrendingUp size={iconSize} />
        {showValue && <span>+{delta}</span>}
      </span>
    );
  }

  if (delta < 0) {
    return (
      <span className={`text-red-600 flex items-center gap-1 font-semibold ${textSize}`}>
        <TrendingDown size={iconSize} />
        {showValue && <span>{delta}</span>}
      </span>
    );
  }

  return (
    <span className={`text-gray-500 flex items-center gap-1 ${textSize}`}>
      <Minus size={iconSize} />
      {showValue && <span>0</span>}
    </span>
  );
}
